import React from 'react';
import { observer } from 'mobx-react';
import {
  BrowserRouter as Router, RouteComponentProps, Switch, Route
} from "react-router-dom";
import EditInstallation from './EditInstallation';
import IndexConnection from './IndexConnection';
import ViewConnection from './ViewConnection';

interface ConnectionProps extends RouteComponentProps {
  changeToggle(action?: boolean): void
}

@observer export default class Connection extends React.Component<ConnectionProps> {
  render() {
    return (
      <Router>
        <Switch >
          <Route exact path="/conexiones"
            render={(props) => (
              <IndexConnection {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/conexiones/ver/:id"
            render={(props) => (
              <ViewConnection {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
          <Route exact path="/conexiones/:id"
            render={(props) => (
              <EditInstallation {...props} changeToggle={this.props.changeToggle} />
            )}>
          </Route>
        </Switch>
      </Router>
    )
  }
}